import * as React from 'react';
import { useParams } from 'react-router-dom';

import { CustomTaskDetails } from '../containers';

export const CustomTaskDetailsPage: React.FC = () => {
  const params = useParams<{ id: string }>();
  const ids = params.id.split('/');

  return (
    <React.Fragment>
      {ids.map((id, index) => (
        <CustomTaskDetails key={index} id={id} />
      ))}
    </React.Fragment>
  );
};
